import styled from 'styled-components';

export const SliderContainer = styled.div`
  position: relative;
  width: ${({ theme }) => theme.width.full};
  overflow: hidden;
  touch-action: pan-y;
  isolation: isolate;
  box-sizing: border-box;
  margin: 0 ${({ theme }) => theme.spacing.m};
  padding-bottom: ${({ theme }) => theme.spacing.m};
`;

export const SliderWrapper = styled.div<{
  translateX: number;
  transitionSpeed: number;
}>`
  display: flex;
  transform: translateX(${({ translateX }) => translateX}%);
  transition: transform ${({ transitionSpeed }) => transitionSpeed}ms
    ease-in-out;
  width: ${({ theme }) => theme.width.full};
  box-sizing: border-box;
`;

export const Slide = styled.div<{ width: number }>`
  min-width: ${(props) => props.width}%;
  max-width: ${(props) => props.width}%;
  flex-shrink: 0;
  flex-grow: 0;
  box-sizing: border-box;
  overflow: hidden;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const DotsContainer = styled.div<{ dotsClass?: string }>`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.s};
  margin-top: ${({ theme }) => theme.spacing.md};
  ${({ dotsClass }) => dotsClass && `.${dotsClass}`}
`;

export const Dot = styled.button<{ isActive: boolean }>`
  width: ${({ theme }) => theme.spacing.sm};
  height: ${({ theme }) => theme.spacing.sm};
  border-radius: ${({ theme }) => theme.radius.xl};
  border: none;
  background-color: ${({ theme, isActive }) => (isActive ? theme.colors.oxfordBlueDark : '#ccc')};
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ isActive }) => (isActive ? '#333' : '#999')};
  }
`;
